import {otaSimList,otaRecharge,otaSimDetail} from 'api/otaSim';
import Cookies from 'js-cookie';

const otaSim = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        otaSimList({commit},params) {
            return new Promise((resolve, reject) => {
                var accountBegin = params.accountBegin;
                var accountEnd = params.accountEnd;
                var imsiBegin = params.imsiBegin;
                var imsiEnd = params.imsiEnd;
                var agent = params.agent;
                var status = params.status;
                var psize = params.psize;
                var currentPage = params.currentPage;
                otaSimList(accountBegin,accountEnd,imsiBegin,imsiEnd,agent,status,psize,currentPage).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        otaSimDetail({commit},params) {
            return new Promise((resolve, reject) => {
                var account = params.account;
                otaSimDetail(account).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        otaRecharge({commit},params) {
            return new Promise((resolve, reject) => {
                otaRecharge(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default otaSim;



// WEBPACK FOOTER //
// ./src/store/modules/otaSim.js